<template lang="pug">
    div.row.cf__users(v-if="$store.state.isUserLoggedIn")
        div.container.indent
            div.tableItems.wh_bl.noCheckbox
                div.titleBlock.fl_l Поьзователи
                    span {{totalUsers}}

                div.tableHeader
                    div.cell.cell-5 id
                    div.cell.cell-40 Пользователь
                    div.cell.cell-15.align-center Статус
                    div.cell.cell-20.align-center Дата
                    div.cell.cell-20.align-right Иструменты
                //tableHeader

                div.tableContent(v-if="usersLength !== 0")
                    div.item(v-for="user in users" :key="user.id")
                        div.cell.cell-5
                            div.name {{user.id || '—'}}
                        div.cell.cell-40
                            div.pic
                                div.imageCover.ratio-1-1.img__abc(:data-abc="toCharAt(user.name)")
                            div.content
                                div.title {{user.name || '—'}}
                                div.email {{user.email || '—'}}
                        div.cell.cell-15.align-center
                            div.name {{user.user_can || '—'}}
                        div.cell.cell-20.align-center
                            div.name {{user.createdAt || '—'}}
                        div.cell.tools.cell-20.align-right
                            //span.status.icon(@click="toggleStatus(user.id)" :class="{'is-active': user.status === 1, 'is-not-active': user.status === 0}")
                                include ../../snippets/power.pug
                            router-link.edit.icon(:to="{ path: `/admin/edit-users/${user.id}`}" v-if="$store.state.user.id === user.id")
                                include ../../snippets/edit.pug
                            span.remove.icon(@click="remove(user.id)" v-if="$store.state.user.id === user.id")
                                include ../../snippets/delete.pug

                //div.emptyContent(v-else) Пусто
            //tableItems

            Pagination.wh_bl(v-model="currentPage" :page-count="totalPages" @update="onChange")
</template>

<script>
    import Pagination from '../components/Pagination';
    import UsersService from '@/services/Users';
    import {mapState} from 'vuex'

    export default {
        name: "users",
        data() {
            return {
                arrayId: [],
                users: null,
                usersLength: 0,
                error: null,

                limitUsers: 10,
                currentPage: 1,
                totalUsers: 0,
                totalPages: 1,
            }
        },
        components: {
            Pagination
        },
        methods: {
            async toggleStatus(id) {
                let array = (id.length > 1) ? id : [id];
                await array.forEach((i) => {
                    const word = this.users.find(r => r.id === i);
                    if (word.status !== null) {
                        let count = (word.status === 1) ? 0 : 1;
                        word.status = count;
                        UsersService.update({"id": i, "status": count});
                    }
                });
            },
            async remove(id) {
                const decision = window.confirm(`Вы уверены, что хотите удалить пользователя? ID-${id}`);
                if (decision) {
                    try {
                        let array = (id.length > 1) ? id : [id];
                        await array.forEach((i) => {
                            const index = this.users.map(w => w.id).indexOf(i);
                            this.users.splice(index, 1);

                        });
                        this.arrayId = [];
                        await UsersService.delete(id);
                        this.totalUsers = (await UsersService.getList(this.currentPage, this.limitUsers)).data.count;

                        this.usersLength = this.users.length;
                        if (this.usersLength === 0 && this.currentPage > 0) {
                            this.onChange(this.currentPage - 1)
                        }
                    } catch (err) {
                        this.error = error
                    }
                }
            },
            async onChange(page) {
                this.currentPage = page;
                this.users = (await UsersService.getList(page, this.limitUsers)).data.rows;
                this.$router.push(this.$route.name + '?page=' + page);
            },
            toCharAt(text) {
                return text.charAt(0).toUpperCase()
            }
        },
        computed: {
            ...mapState(['isUserLoggedIn']),
        },
        watch: {
            '$route': {
                immediate: true,
                async handler(value) {
                    if (value.query.search) {
                        let search = value.query.search;
                        this.users = (await UsersService.getAll(search)).data;
                    } else {

                        let page = this.$route.query.page;

                        this.currentPage = (isNaN(page) || !isFinite(page)) ? 1 : Number(page);
                        this.$router.push(this.$route.name + '?page=' + this.currentPage);
                        let data = (await UsersService.getList(this.currentPage, this.limitUsers)).data;
                        this.usersLength = Number(data.rows.length);
                        this.totalPages = Number(data.pages);
                        this.totalUsers = Number(data.count);
                        this.users = await data.rows;
                    }
                }
            }
        }
    }
</script>
